export const CALC_KIND_LABELS = {
  BASE: "Base del servicio",
  INCREMENT_PER_UNIT: "Incremento por unidad",
  ONE_TIME_SURCHARGE: "Recargo único",
  HOURLY: "Cobro por hora",
  MINIMUM_FARE: "Valor mínimo",
};

export const CALC_KIND_BADGE_COLORS = {
  BASE: "blue",
  INCREMENT_PER_UNIT: "green",
  ONE_TIME_SURCHARGE: "orange",
  HOURLY: "teal",
  MINIMUM_FARE: "purple",
};

export function humanizeCalcKind(kind) {
  return CALC_KIND_LABELS[kind] ?? kind;
}

export function humanizeName(value) {
  if (!value) return "";

  return String(value)
    .toLowerCase()
    .replace(/[_-]+/g, " ")          // _ y - → espacio
    .replace(/\s+/g, " ")            // espacios dobles
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase()); // Primera letra mayúscula
}

export const UNIT_LABELS = {
  service: "Servicio",
  flat: "Valor fijo",
  meter: "Metros",
  hour: "Hora",
  second: "Segundos",
};

export function humanizeUnit(unit) {
  if (!unit) return "—";
  return UNIT_LABELS[unit] ?? humanizeName(unit);
}

export function summaryByKind(c) {
    switch (c.calc_kind) {
      case "BASE":
        return "Valor base del servicio.";

      case "INCREMENT_PER_UNIT":
        return `Incremento por cada ${
          c.unit_qty ?? "bloque"
        } ${humanizeUnit(c.unit).toLowerCase()}.`;

      case "ONE_TIME_SURCHARGE":
        return "Recargo único por evento.";

      case "HOURLY":
        return "Cobro por cada hora transcurrida.";

      case "MINIMUM_FARE":
        return "Asegura un valor mínimo del viaje.";

      default:
        return "";
    }
  }


